import { render } from "./NameType.vue?vue&type=template&id=8bb20b72&scoped=true"
import script from "./NameType.vue?vue&type=script&lang=js"
export * from "./NameType.vue?vue&type=script&lang=js"

import "./NameType.vue?vue&type=style&index=0&id=8bb20b72&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-8bb20b72"

export default script